import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const TimesheetHourContainerStyled = styled(Box)`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;
